export enum Bracket {
  angle = '<>',
  curly = '{}',
  round = '()',
  square = '[]'
}

export function removeBrackets(input: string, bracket: Bracket): string {
  const [open, close] = bracket.split('');
  const regex = new RegExp(`\\${open}[^\\${open}\\${close}]*\\${close}`, 'g');

  while (regex.test(input)) {
    input = input.replace(regex, '');
  }

  return input;
}
